<div class="bg-pricing">
  <div class="section-wrapper">
    <section id="pricing" class="container-pricing--xs">
      <h2>Pricing</h2>
      <div class="card blue-top-line">
        <h3>Tarif unique</h3>
        <div class="price"><span>2€ HT</span> /collaborateur /mois</div>
        <p><strong>La tarification est très simple !</strong></p>
        <p>
          Notre solution coûte 2€ par collaborateur actif et par mois, c'est-à-dire pour lequel un document peut être produit. Les
          collaborateurs archivés ne sont pas comptabilisés.
        </p>
        <p>Les signatures électroniques sont refacturées au réel de leur consommation, 2€ par signature.</p>
      </div>
    </section>
  </div>
</div>
